import { CLOSE_ALERT, ADD_ALERT } from '../constants/action-types';

export const closeAlert = (index) => {
    return { type: CLOSE_ALERT, payload: index};
}

export const addAlert = (alert) => {
    return { type: ADD_ALERT, payload: alert };
}
